<template>
  <div class="InvoiceDetailsBox">
    <van-popup
      v-model="showPopup"
      position="bottom"
      @close="onClose"
      :style="{ height: '80%' }"
      :closeable="true"
    >
      <div class="popoverContent">
        <div class="popoverContentTop">
          <div class="title">近三年汇总</div>
          <div class="tipBox">
            <div class="marginRight">
              <span class="key">单位：</span>
              <span class="value">万元</span>
            </div>
            <div>
              <span class="key">数据更新时间：</span>
              <span class="value">{{ updateTime }}</span>
            </div>
          </div>
        </div>
        <div class="invoiceTable">
          <div class="tableList">
            <ul class="invoiceTableHead">
              <li class="monthTitle">月/年</li>
              <li class="nearlyaYear">{{ thisYear }}</li>
              <li class="nearlyTwoYear">{{ lastYear }}</li>
              <li class="nearlyThereYear">{{ last2Years }}</li>
            </ul>
            <div class="noData" v-show="invoiceDetailList.length === 0">
              暂无数据
            </div>
            <div class="content">
              <ul
                v-show="invoiceDetailList.length > 0"
                class="invoiceTablebody"
                :style="{
                  background: e.month === '总计' ? '#fff3ef' : '#fff',
                  height: e.month === '总计' ? '32px' : '',
                }"
                v-for="(e, index) in invoiceDetailList"
                :key="index"
              >
                <li :class="e.month === '总计' ? 'fontWeight month' : 'month'">
                  {{ e.month }}
                </li>
                <li
                  :class="
                    e.month === '总计'
                      ? 'fontWeight nearlyaYear'
                      : 'nearlyaYear'
                  "
                >
                  {{ filterText(e.nearlyaYear) }}
                </li>
                <li
                  :class="
                    e.month === '总计'
                      ? 'fontWeight nearlyTwoYear'
                      : 'nearlyTwoYear'
                  "
                >
                  {{ filterText(e.nearlyTwoYear) }}
                </li>
                <li
                  :class="
                    e.month === '总计'
                      ? 'fontWeight nearlyThereYear'
                      : 'nearlyThereYear'
                  "
                >
                  {{ filterText(e.nearlyThereYear) }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="popoverContentBottom">
          <div class="title" style="margin-top: 12px">数据指标</div>
          <div class="popoverContentVal">
            <span class="key">近12个月开票额：</span>
            <span class="value">{{ oneYearAmount }}万元</span>
          </div>
        </div>

        <div class="buttonGroup" v-if="title === '请确认发票数据'">
          <div class="cancel" @click="onCancel">取消</div>
          <div class="submit" @click="onDetermine">确认</div>
        </div>
      </div>
    </van-popup>
    <!-- <ShowTips ref="tips" @clickUpload="clickUpload"></ShowTips> -->
  </div>
</template>

<script>
import { toThousands } from '@/utils/index';
// eslint-disable-next-line import/extensions
// import ShowTips from '../ShowTips';

function debounce(func, wait) {
  let timeout;
  return function (...argument) {
    const context = this;
    const args = argument;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
export default {
  name: 'InvoiceDetails',
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
    },
  },
  components: {
    // ShowTips,
  },
  data() {
    return {
      invoiceDetailList: [],
      oneYearAmount: '',
      updateTime: '',
      showPopup: false,
      timer: null,
      thisYear: '',
      lastYear: '',
      last2Years: '',
    };
  },
  mounted() {},
  watch: {
    value: {
      handler(newValue) {
        this.showPopup = newValue;
        if (newValue) {
          this.getData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('input', false);
    },
    onDetermine: debounce(function () {
      this.$emit('onSubmit');
    }, 500),
    onCancel() {
      this.$emit('input', false);
    },
    filterText(text) {
      if (text === '0.00') {
        return '0.00';
      }
      if (text) {
        return toThousands(text) || text;
      }
      return text;
    },
    clickUpload() {
      this.showPopup = false;
    },
    showDialog(data) {
      // 近3个月的数据是否为空，空提示弹框
      // 不包含当月，如果当前是6月份，前三个月就是 5，4，3
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() - 1;

      const date = new Date(currentYear, currentMonth);
      const month = date.getMonth();
      const year = date.getFullYear();
      console.log(year, month, '上个月的时间');

      const prevMonthTime = new Date(year, month - 1);
      const prevMonth = prevMonthTime.getMonth();
      const prevYear = prevMonthTime.getFullYear();
      console.log(prevYear, prevMonth, '上两个月的时间');

      const prevTowMonthTime = new Date(year, month - 2);
      const prevMonth2 = prevTowMonthTime.getMonth();
      const prevYear2 = prevTowMonthTime.getFullYear();
      console.log(prevYear2, prevMonth2, '上三个月的时间');

      let total = 0;
      data.forEach((v) => {
        if (year === Number(v.year)) {
          total += Number(v.amounts[month]);
        }

        if (prevYear === Number(v.year)) {
          total += Number(v.amounts[prevMonth]);
        }

        if (prevYear2 === Number(v.year)) {
          total += Number(v.amounts[prevMonth2]);
        }
      });
      // if (!total) {
      //   this.$refs.tips.showTips = true;
      // }
      // console.log(total, 'total');
    },
    async getData() {
      const {
        returnCode,
        data: { invoiceStat, oneYearAmount, updateTime },
      } = await this.$api.PublicPage.getInvoiceDetailList({
        taxNo: this.$route.query.taxNo,
        orderId: this.$route.query.orderId,
      });
      try {
        if (returnCode === '200') {
          this.oneYearAmount = oneYearAmount;
          this.updateTime = updateTime;
          if (invoiceStat && invoiceStat.length > 0) {
            const List = [];
            invoiceStat[0].amounts.forEach((e, index) => {
              List.push({
                month: index + 1,
                nearlyaYear: invoiceStat[2].amounts[index],
                nearlyTwoYear: invoiceStat[1].amounts[index],
                nearlyThereYear: e,
              });
            });
            this.thisYear = invoiceStat[2].year;
            this.lastYear = invoiceStat[1].year;
            this.last2Years = invoiceStat[0].year;

            this.invoiceDetailList = [
              ...List,
              {
                month: '总计',
                nearlyaYear: this.getTotal(List, 'nearlyaYear').toFixed(2),
                nearlyTwoYear: this.getTotal(List, 'nearlyTwoYear').toFixed(2),
                nearlyThereYear: this.getTotal(List, 'nearlyThereYear').toFixed(
                  2,
                ),
              },
            ];
            if (this.title === '请确认发票数据') {
              this.showDialog(invoiceStat);
            }
          }
        } else {
          this.invoiceDetailList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    getTotal(data, index) {
      return data.reduce((e, s) => {
        if (typeof e === 'number') {
          return (e || 0) * 1 + (s[index] || 0) * 1;
        }
        return (e[index] || 0) * 1 + (s[index] || 0) * 1;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  height: 68px;
  background: #fff;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-top: 0.5px solid #cccccc;
  box-sizing: border-box;
  .cancel {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #2f3133;
    text-align: center;
    font-weight: 400;
    text-align: center;
    line-height: 44px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #bcc2cc;
    border-radius: 4px;
    flex: 1;
    margin-right: 15px;
  }
  .submit {
    background: #ff6538;
    border-radius: 4px;
    flex: 1;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    height: 44px;
    line-height: 44px;
    height: 44px;
  }
}
.InvoiceDetailsBox {
  width: auto;
  height: auto;
}
.InvoiceDetails {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  font-family: "Microsoft YaHei";
  padding: 0 16px;
}
.text {
  font-size: 14px;
  color: #bcc2cc;
  font-weight: 400;
}
.detailsEntrance {
  font-size: 14px;
  color: #ff6538;
  text-align: right;
  margin-left: 2px;
}

.popoverContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.invoiceTable {
  text-align: left;
  // background: #fff7f5;
  flex: 1;
  overflow: hidden;
  .tableList {
    display: flex;
    flex-direction: column;
    height: 100%;
    .content {
      flex: 1;
      overflow: auto;
    }
  }
}
.title {
  text-align: left;
  font-size: 14px;
  color: #2f3133;
  font-weight: 600;
  margin: 16px 0 4px 16px;
}
.tipBox {
  display: flex;
  flex-direction: row;
  margin: 0 0 8px 16px;
}
.marginRight {
  margin-right: 12px;
}
.key {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #767980;
  line-height: 18px;
  font-weight: 400;
}
.value {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #46494d;
  line-height: 18px;
  font-weight: 400;
}
.popoverContentVal {
  height: 32px;
  line-height: 32px;
  text-align: left;
  padding-left: 16px;
  background: #fff3ef;
}
.invoiceTablebody {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #46494d;
  text-align: right;
  font-weight: 400;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  // margin-bottom: 18px;
  // font-size: 12px;
}
.invoiceTableHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  background: #ff6538;
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
}
.monthTitle {
  min-width: 40px;
  text-align: left;
}
.month {
  width: 40px;
  text-align: left;
}
.nearlyaYear {
  min-width: 100px;
  text-align: right;
}
.nearlyTwoYear {
  min-width: 100px;
  text-align: right;
}
.nearlyThereYear {
  text-align: right;
  min-width: 100px;
}
.fontWeight {
  font-weight: bold;
}
.noData {
  width: 100%;
  height: 300px;
  font-size: 12px;
  background: #fff;
  color: #bcc2cc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popoverContentBottom {
  margin-bottom: 12px;
}
</style>
